/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date; }
};

export type AddressCandidate = {
  __typename?: 'AddressCandidate';
  city: Scalars['String']['output'];
  cityKana: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  prefectureKana: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  streetAddressKana: Scalars['String']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  performanceTrend: AdminPerformanceTrend;
  purchase?: Maybe<AdminPurchaseDetail>;
  purchases: AdminPurchaseConnection;
  restaurant?: Maybe<AdminRestaurant>;
  restaurantFilterMaster: AdminRestaurantFilterMaster;
  restaurantListSummary: AdminRestaurantListSummary;
  restaurants: AdminRestaurantConnection;
  settingTerms: AdminSettingTerms;
  ticketFilters: Array<AdminTicketFilter>;
  ticketUsageSummary: AdminTicketUsageSummary;
  user?: Maybe<AdminUser>;
  users: Array<AdminUser>;
};


export type AdminPerformanceTrendArgs = {
  input: AdminPerformanceTrendInput;
};


export type AdminPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type AdminPurchasesArgs = {
  input: AdminPurchasesInput;
};


export type AdminRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type AdminRestaurantListSummaryArgs = {
  input: AdminRestaurantListSummaryInput;
};


export type AdminRestaurantsArgs = {
  input: AdminRestaurantsInput;
};


export type AdminTicketUsageSummaryArgs = {
  input: AdminTicketUsageSummaryInput;
};


export type AdminUserArgs = {
  id: Scalars['ID']['input'];
};


export type AdminUsersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};

export enum AdminContractPlan {
  Standard = 'STANDARD',
  Suspended = 'SUSPENDED'
}

export enum AdminPerformancePeriodUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type AdminPerformanceTrend = {
  __typename?: 'AdminPerformanceTrend';
  periodUnit: AdminPerformancePeriodUnit;
  rows: Array<AdminPerformanceTrendRow>;
};

export type AdminPerformanceTrendInput = {
  date: Scalars['String']['input'];
  periodUnit: AdminPerformancePeriodUnit;
  ticketFilterId?: InputMaybe<Scalars['ID']['input']>;
};

export type AdminPerformanceTrendRow = {
  __typename?: 'AdminPerformanceTrendRow';
  distributionGrossAmount: Scalars['Int']['output'];
  distributionGrossDiff: Scalars['Int']['output'];
  periodLabel: Scalars['String']['output'];
  registeredShopCount: Scalars['Int']['output'];
  registeredShopDiff: Scalars['Int']['output'];
  revenueAmount: Scalars['Int']['output'];
  revenueDiff: Scalars['Int']['output'];
  soldTicketCount: Scalars['Int']['output'];
  soldTicketDiff: Scalars['Int']['output'];
};

export type AdminPurchase = {
  __typename?: 'AdminPurchase';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  ticket: Ticket;
  transactionType: AdminPurchaseTransactionType;
};

export type AdminPurchaseConnection = {
  __typename?: 'AdminPurchaseConnection';
  edges: Array<AdminPurchaseEdge>;
  nodes: Array<AdminPurchase>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminPurchaseDetail = {
  __typename?: 'AdminPurchaseDetail';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
  purchaser: AdminPurchaseDetailPurchaser;
  ticket: Ticket;
  timeline: Array<AdminPurchaseTimelineItem>;
};

export type AdminPurchaseDetailPurchaser = {
  __typename?: 'AdminPurchaseDetailPurchaser';
  email: Scalars['String']['output'];
  type: AdminPurchasePurchaserType;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminPurchaseEdge = {
  __typename?: 'AdminPurchaseEdge';
  cursor: Scalars['String']['output'];
  node: AdminPurchase;
};

export enum AdminPurchasePurchaserType {
  Authenticated = 'AUTHENTICATED',
  Guest = 'GUEST'
}

export type AdminPurchaseTimelineItem = {
  __typename?: 'AdminPurchaseTimelineItem';
  occurredAt: Scalars['DateTime']['output'];
  paymentMethod: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  settlementAmount: Scalars['Int']['output'];
  ticketPrice: Scalars['Int']['output'];
  transactionType: AdminPurchaseTransactionType;
};

export enum AdminPurchaseTransactionType {
  Purchase = 'PURCHASE',
  Refunded = 'REFUNDED',
  Used = 'USED'
}

export type AdminPurchasesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
  transactionType?: InputMaybe<AdminPurchaseTransactionType>;
};

export type AdminRefundPurchaseError = {
  __typename?: 'AdminRefundPurchaseError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminRefundPurchaseInput = {
  purchaseId: Scalars['ID']['input'];
};

export type AdminRefundPurchaseResult = AdminRefundPurchaseError | AdminRefundPurchaseSuccess;

export type AdminRefundPurchaseSuccess = {
  __typename?: 'AdminRefundPurchaseSuccess';
  purchase: AdminRefundPurchaseSuccessPurchase;
  refundedTimelineItem: AdminPurchaseTimelineItem;
};

export type AdminRefundPurchaseSuccessPurchase = {
  __typename?: 'AdminRefundPurchaseSuccessPurchase';
  id: Scalars['ID']['output'];
  purchaseCode: Scalars['String']['output'];
};

export type AdminRestaurant = {
  __typename?: 'AdminRestaurant';
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  contractPlan: AdminContractPlan;
  id: Scalars['ID']['output'];
  monthlySalesAmount: Scalars['Int']['output'];
  operatingCompanyName: Scalars['String']['output'];
  salesFeeRatePercent: Scalars['Int']['output'];
  salesSummary: AdminRestaurantSalesSummary;
  salesTrend: AdminRestaurantSalesTrend;
  shop: Shop;
  ticket?: Maybe<Ticket>;
  ticketListSummary: AdminRestaurantTicketListSummary;
  tickets: AdminRestaurantTicketConnection;
};


export type AdminRestaurantSalesSummaryArgs = {
  input: AdminRestaurantSalesSummaryInput;
};


export type AdminRestaurantSalesTrendArgs = {
  input: AdminRestaurantSalesTrendInput;
};


export type AdminRestaurantTicketArgs = {
  id: Scalars['ID']['input'];
};


export type AdminRestaurantTicketListSummaryArgs = {
  input: AdminRestaurantTicketListSummaryInput;
};


export type AdminRestaurantTicketsArgs = {
  input: AdminRestaurantTicketsInput;
};

export type AdminRestaurantConnection = {
  __typename?: 'AdminRestaurantConnection';
  edges: Array<AdminRestaurantEdge>;
  nodes: Array<AdminRestaurant>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminRestaurantEdge = {
  __typename?: 'AdminRestaurantEdge';
  cursor: Scalars['String']['output'];
  node: AdminRestaurant;
};

export type AdminRestaurantFilterContractPlan = {
  __typename?: 'AdminRestaurantFilterContractPlan';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AdminRestaurantFilterMaster = {
  __typename?: 'AdminRestaurantFilterMaster';
  contractPlans: Array<AdminRestaurantFilterContractPlan>;
  prefectures: Array<AdminRestaurantFilterPrefecture>;
};

export type AdminRestaurantFilterPrefecture = {
  __typename?: 'AdminRestaurantFilterPrefecture';
  areaCode: Scalars['String']['output'];
  areaName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AdminRestaurantListSummary = {
  __typename?: 'AdminRestaurantListSummary';
  registeredRestaurantCount: Scalars['Int']['output'];
  registeredRestaurantDiffFromPreviousMonth: Scalars['Int']['output'];
};

export type AdminRestaurantListSummaryInput = {
  targetMonth: Scalars['String']['input'];
};

export type AdminRestaurantSalesSummary = {
  __typename?: 'AdminRestaurantSalesSummary';
  availableTicketCount: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  purchasedUnusedTicketCount: Scalars['Int']['output'];
  usedTicketCount: Scalars['Int']['output'];
};

export type AdminRestaurantSalesSummaryInput = {
  date: Scalars['String']['input'];
  periodUnit?: InputMaybe<AdminPerformancePeriodUnit>;
};

export type AdminRestaurantSalesTrend = {
  __typename?: 'AdminRestaurantSalesTrend';
  rows: Array<AdminRestaurantSalesTrendRow>;
};

export type AdminRestaurantSalesTrendInput = {
  anchorDate: Scalars['String']['input'];
  periodUnit: AdminPerformancePeriodUnit;
};

export type AdminRestaurantSalesTrendRow = {
  __typename?: 'AdminRestaurantSalesTrendRow';
  distributionGrossAmount: Scalars['Int']['output'];
  distributionGrossDiff: Scalars['Int']['output'];
  periodLabel: Scalars['String']['output'];
  revenueAmount: Scalars['Int']['output'];
  revenueDiff: Scalars['Int']['output'];
  soldTicketCount: Scalars['Int']['output'];
  soldTicketDiff: Scalars['Int']['output'];
};

export type AdminRestaurantTicketConnection = {
  __typename?: 'AdminRestaurantTicketConnection';
  edges: Array<AdminRestaurantTicketEdge>;
  nodes: Array<Ticket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AdminRestaurantTicketEdge = {
  __typename?: 'AdminRestaurantTicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type AdminRestaurantTicketListSummary = {
  __typename?: 'AdminRestaurantTicketListSummary';
  monthlySalesAmount: Scalars['Int']['output'];
  monthlySalesDiffFromPreviousMonth: Scalars['Int']['output'];
};

export type AdminRestaurantTicketListSummaryInput = {
  targetMonth: Scalars['String']['input'];
};

export type AdminRestaurantTicketsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketPublicationStatus>;
};

export type AdminRestaurantsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  contractPlan?: InputMaybe<AdminContractPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  prefectureCode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AdminRestaurantsSort>;
};

export enum AdminRestaurantsSort {
  MonthlySalesAsc = 'MONTHLY_SALES_ASC',
  MonthlySalesDesc = 'MONTHLY_SALES_DESC',
  SalesFeeRateAsc = 'SALES_FEE_RATE_ASC',
  SalesFeeRateDesc = 'SALES_FEE_RATE_DESC'
}

export type AdminSettingTerms = {
  __typename?: 'AdminSettingTerms';
  privacyPolicy: Scalars['String']['output'];
  termsOfService: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AdminTicketFilter = {
  __typename?: 'AdminTicketFilter';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AdminTicketUsageSummary = {
  __typename?: 'AdminTicketUsageSummary';
  availableTickets: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  purchasedUnusedTickets: Scalars['Int']['output'];
  usedTickets: Scalars['Int']['output'];
};

export type AdminTicketUsageSummaryInput = {
  date: Scalars['String']['input'];
  periodUnit?: InputMaybe<AdminPerformancePeriodUnit>;
};

export type AdminUpdateRestaurantContractPlanError = {
  __typename?: 'AdminUpdateRestaurantContractPlanError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateRestaurantContractPlanInput = {
  contractPlan: AdminContractPlan;
  restaurantId: Scalars['ID']['input'];
};

export type AdminUpdateRestaurantContractPlanResult = AdminRestaurant | AdminUpdateRestaurantContractPlanError;

export type AdminUpdateRestaurantSalesFeeError = {
  __typename?: 'AdminUpdateRestaurantSalesFeeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateRestaurantSalesFeeInput = {
  restaurantId: Scalars['ID']['input'];
  salesFeeRatePercent: Scalars['Int']['input'];
};

export type AdminUpdateRestaurantSalesFeeResult = AdminRestaurant | AdminUpdateRestaurantSalesFeeError;

export type AdminUpdateTicketStatusError = {
  __typename?: 'AdminUpdateTicketStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type AdminUpdateTicketStatusInput = {
  restaurantId: Scalars['ID']['input'];
  status: TicketPublicationStatus;
  ticketId: Scalars['ID']['input'];
};

export type AdminUpdateTicketStatusResult = AdminUpdateTicketStatusError | Ticket;

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Area = {
  __typename?: 'Area';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  prefectures: Array<Prefecture>;
};


export type AreaLabelArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export type CompleteGuestPurchaseTicketCheckoutError = {
  __typename?: 'CompleteGuestPurchaseTicketCheckoutError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CompleteGuestPurchaseTicketCheckoutInput = {
  langCode: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type CompleteGuestPurchaseTicketCheckoutResult = CompleteGuestPurchaseTicketCheckoutError | CompleteGuestPurchaseTicketCheckoutSuccess;

export type CompleteGuestPurchaseTicketCheckoutSuccess = {
  __typename?: 'CompleteGuestPurchaseTicketCheckoutSuccess';
  purchase: Purchase;
  ticketAccessToken: Scalars['String']['output'];
};

export type CompletePurchaseTicketCheckoutError = {
  __typename?: 'CompletePurchaseTicketCheckoutError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CompletePurchaseTicketCheckoutInput = {
  langCode: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type CompletePurchaseTicketCheckoutResult = CompletePurchaseTicketCheckoutError | Purchase;

export type CreateGuestPurchaseCheckoutSessionError = {
  __typename?: 'CreateGuestPurchaseCheckoutSessionError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateGuestPurchaseCheckoutSessionInput = {
  langCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type CreateGuestPurchaseCheckoutSessionResult = CreateGuestPurchaseCheckoutSessionError | CreateGuestPurchaseCheckoutSessionSuccess;

export type CreateGuestPurchaseCheckoutSessionSuccess = {
  __typename?: 'CreateGuestPurchaseCheckoutSessionSuccess';
  clientSecret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CreatePurchaseCheckoutSessionError = {
  __typename?: 'CreatePurchaseCheckoutSessionError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreatePurchaseCheckoutSessionInput = {
  langCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};

export type CreatePurchaseCheckoutSessionResult = CreatePurchaseCheckoutSessionError | CreatePurchaseCheckoutSessionSuccess;

export type CreatePurchaseCheckoutSessionSuccess = {
  __typename?: 'CreatePurchaseCheckoutSessionSuccess';
  clientSecret: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type CreateTenantAccountError = {
  __typename?: 'CreateTenantAccountError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateTenantAccountInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhoneNumber: Scalars['String']['input'];
  operatingCompanyName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
  shopEmail: Scalars['String']['input'];
  shopName: Scalars['String']['input'];
  shopPhoneNumber: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type CreateTenantAccountResult = CreateTenantAccountError | Restaurant;

export type CreateTenantTicketError = {
  __typename?: 'CreateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type CreateTenantTicketInput = {
  availableWeekdays?: InputMaybe<Array<TicketAvailableWeekday>>;
  dailyStock: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  expiryDays: Scalars['Int']['input'];
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  maxPartySize: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  pricingTiers: Array<CreateTenantTicketPricingTierInput>;
  purchaseTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  purchaseTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
  status: TicketPublicationStatus;
  validTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  validTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTenantTicketPricingTierInput = {
  pricePerPerson: Scalars['Int']['input'];
  upToQuantity: Scalars['Int']['input'];
};

export type CreateTenantTicketResult = CreateTenantTicketError | Ticket;

export type DeleteAccountError = {
  __typename?: 'DeleteAccountError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteAccountInput = {
  confirmDeletion: Scalars['Boolean']['input'];
};

export type DeleteAccountResult = DeleteAccountError | DeleteAccountSuccess;

export type DeleteAccountSuccess = {
  __typename?: 'DeleteAccountSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteSavedCardsError = {
  __typename?: 'DeleteSavedCardsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteSavedCardsResult = DeleteSavedCardsError | DeleteSavedCardsSuccess;

export type DeleteSavedCardsSuccess = {
  __typename?: 'DeleteSavedCardsSuccess';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantMemberError = {
  __typename?: 'DeleteTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteTenantMemberResult = {
  __typename?: 'DeleteTenantMemberResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantMemberUnion = DeleteTenantMemberError | DeleteTenantMemberResult;

export type DeleteTenantTicketError = {
  __typename?: 'DeleteTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DeleteTenantTicketResult = {
  __typename?: 'DeleteTenantTicketResult';
  success: Scalars['Boolean']['output'];
};

export type DeleteTenantTicketUnion = DeleteTenantTicketError | DeleteTenantTicketResult;

export type DuplicateTenantTicketError = {
  __typename?: 'DuplicateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type DuplicateTenantTicketInput = {
  ticketId: Scalars['ID']['input'];
};

export type DuplicateTenantTicketResult = DuplicateTenantTicketError | Ticket;

export enum ErrorCode {
  Aborted = 'ABORTED',
  AlreadyExists = 'ALREADY_EXISTS',
  Cancelled = 'CANCELLED',
  DataLoss = 'DATA_LOSS',
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  FailedPrecondition = 'FAILED_PRECONDITION',
  Internal = 'INTERNAL',
  InvalidArgument = 'INVALID_ARGUMENT',
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  OutOfRange = 'OUT_OF_RANGE',
  PermissionDenied = 'PERMISSION_DENIED',
  ResourceExhausted = 'RESOURCE_EXHAUSTED',
  Unauthenticated = 'UNAUTHENTICATED',
  Unavailable = 'UNAVAILABLE',
  Unimplemented = 'UNIMPLEMENTED',
  Unknown = 'UNKNOWN'
}

export type GrantAdminRoleByEmailError = {
  __typename?: 'GrantAdminRoleByEmailError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GrantAdminRoleByEmailInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GrantAdminRoleByEmailResult = AdminUser | GrantAdminRoleByEmailError;

export type GrantAdminRoleError = {
  __typename?: 'GrantAdminRoleError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GrantAdminRoleInput = {
  userId: Scalars['ID']['input'];
};

export type GrantAdminRoleResult = AdminUser | GrantAdminRoleError;

export type Guest = {
  __typename?: 'Guest';
  purchaseCheckoutSessionStatus: GuestPurchaseCheckoutSessionStatusResult;
  purchasedTicket: Purchase;
};


export type GuestPurchaseCheckoutSessionStatusArgs = {
  sessionId: Scalars['String']['input'];
};


export type GuestPurchasedTicketArgs = {
  ticketAccessToken: Scalars['String']['input'];
};

export type GuestPurchaseCheckoutSessionStatus = {
  __typename?: 'GuestPurchaseCheckoutSessionStatus';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  ticketAccessToken?: Maybe<Scalars['String']['output']>;
};

export type GuestPurchaseCheckoutSessionStatusError = {
  __typename?: 'GuestPurchaseCheckoutSessionStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type GuestPurchaseCheckoutSessionStatusResult = GuestPurchaseCheckoutSessionStatus | GuestPurchaseCheckoutSessionStatusError;

export type InviteMemberInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: TenantMembershipRole;
};

export type InviteTenantMemberError = {
  __typename?: 'InviteTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type InviteTenantMemberResult = InviteTenantMemberError | TenantMember;

export type MarkPurchaseUsedError = {
  __typename?: 'MarkPurchaseUsedError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type MarkPurchaseUsedInput = {
  purchaseId: Scalars['ID']['input'];
};

export type MarkPurchaseUsedResult = MarkPurchaseUsedError | TenantPurchase;

export type Me = {
  __typename?: 'Me';
  email: Scalars['String']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  purchasedTicket?: Maybe<Purchase>;
  purchasedTickets: PurchaseConnection;
  savedCards: Array<SavedCard>;
};


export type MePurchasedTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MePurchasedTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<PurchasedTicketStatus>;
};

export type Mutation = {
  __typename?: 'Mutation';
  adminRefundPurchase: AdminRefundPurchaseResult;
  adminUpdateRestaurantContractPlan: AdminUpdateRestaurantContractPlanResult;
  adminUpdateRestaurantSalesFee: AdminUpdateRestaurantSalesFeeResult;
  adminUpdateTicketStatus: AdminUpdateTicketStatusResult;
  completeGuestPurchaseTicketCheckout: CompleteGuestPurchaseTicketCheckoutResult;
  completePurchaseTicketCheckout: CompletePurchaseTicketCheckoutResult;
  createGuestPurchaseCheckoutSession: CreateGuestPurchaseCheckoutSessionResult;
  createPurchaseCheckoutSession: CreatePurchaseCheckoutSessionResult;
  createTenantAccount: CreateTenantAccountResult;
  createTenantTicket: CreateTenantTicketResult;
  deleteAccount: DeleteAccountResult;
  deleteSavedCards: DeleteSavedCardsResult;
  deleteTenantMember: DeleteTenantMemberUnion;
  deleteTenantTicket: DeleteTenantTicketUnion;
  duplicateTenantTicket: DuplicateTenantTicketResult;
  grantAdminRole: GrantAdminRoleResult;
  grantAdminRoleByEmail: GrantAdminRoleByEmailResult;
  inviteTenantMember: InviteTenantMemberResult;
  markPurchaseUsed: MarkPurchaseUsedResult;
  previewTicketTranslations: PreviewTicketTranslationsResult;
  promoteTenantManager: PromoteTenantManagerUnion;
  revokeAdminRole: RevokeAdminRoleResult;
  saveCard: SaveCardResult;
  toggleTicketActive: ToggleTicketActiveResult;
  updateAdminSettingTerms: UpdateAdminSettingTermsResult;
  updateAdminUser: UpdateAdminUserResult;
  updateCheckoutSessionTicketRecipientEmail: UpdateCheckoutSessionTicketRecipientEmailResult;
  updateTenantMember: UpdateTenantMemberResult;
  updateTenantShopSettings: UpdateTenantShopSettingsResult;
  updateTenantTicket: UpdateTenantTicketResult;
  updateTenantTicketSettings: UpdateTenantTicketSettingsResult;
  useGuestTicketWithCode: UseGuestTicketWithCodeResult;
  useTicketWithCode: UseTicketWithCodeResult;
};


export type MutationAdminRefundPurchaseArgs = {
  input: AdminRefundPurchaseInput;
};


export type MutationAdminUpdateRestaurantContractPlanArgs = {
  input: AdminUpdateRestaurantContractPlanInput;
};


export type MutationAdminUpdateRestaurantSalesFeeArgs = {
  input: AdminUpdateRestaurantSalesFeeInput;
};


export type MutationAdminUpdateTicketStatusArgs = {
  input: AdminUpdateTicketStatusInput;
};


export type MutationCompleteGuestPurchaseTicketCheckoutArgs = {
  input: CompleteGuestPurchaseTicketCheckoutInput;
};


export type MutationCompletePurchaseTicketCheckoutArgs = {
  input: CompletePurchaseTicketCheckoutInput;
};


export type MutationCreateGuestPurchaseCheckoutSessionArgs = {
  input: CreateGuestPurchaseCheckoutSessionInput;
};


export type MutationCreatePurchaseCheckoutSessionArgs = {
  input: CreatePurchaseCheckoutSessionInput;
};


export type MutationCreateTenantAccountArgs = {
  input: CreateTenantAccountInput;
};


export type MutationCreateTenantTicketArgs = {
  input: CreateTenantTicketInput;
};


export type MutationDeleteAccountArgs = {
  input: DeleteAccountInput;
};


export type MutationDeleteTenantMemberArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationDeleteTenantTicketArgs = {
  ticketId: Scalars['ID']['input'];
};


export type MutationDuplicateTenantTicketArgs = {
  input: DuplicateTenantTicketInput;
};


export type MutationGrantAdminRoleArgs = {
  input: GrantAdminRoleInput;
};


export type MutationGrantAdminRoleByEmailArgs = {
  input: GrantAdminRoleByEmailInput;
};


export type MutationInviteTenantMemberArgs = {
  input: InviteMemberInput;
};


export type MutationMarkPurchaseUsedArgs = {
  input: MarkPurchaseUsedInput;
};


export type MutationPreviewTicketTranslationsArgs = {
  input: PreviewTicketTranslationsInput;
};


export type MutationPromoteTenantManagerArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationRevokeAdminRoleArgs = {
  input: RevokeAdminRoleInput;
};


export type MutationSaveCardArgs = {
  input: SaveCardInput;
};


export type MutationToggleTicketActiveArgs = {
  status: TicketPublicationStatus;
  ticketId: Scalars['ID']['input'];
};


export type MutationUpdateAdminSettingTermsArgs = {
  input: UpdateAdminSettingTermsInput;
};


export type MutationUpdateAdminUserArgs = {
  input: UpdateAdminUserInput;
};


export type MutationUpdateCheckoutSessionTicketRecipientEmailArgs = {
  input: UpdateCheckoutSessionTicketRecipientEmailInput;
};


export type MutationUpdateTenantMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateTenantShopSettingsArgs = {
  input: UpdateShopSettingsInput;
};


export type MutationUpdateTenantTicketArgs = {
  input: UpdateTenantTicketInput;
};


export type MutationUpdateTenantTicketSettingsArgs = {
  input: UpdateTicketSettingsInput;
};


export type MutationUseGuestTicketWithCodeArgs = {
  input: UseGuestTicketWithCodeInput;
};


export type MutationUseTicketWithCodeArgs = {
  input: UseTicketWithCodeInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaymentMethod {
  ApplePay = 'APPLE_PAY',
  CreditCard = 'CREDIT_CARD',
  GooglePay = 'GOOGLE_PAY',
  Paypay = 'PAYPAY'
}

export type Prefecture = {
  __typename?: 'Prefecture';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};


export type PrefectureLabelArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export type PreviewTicketTranslationsError = {
  __typename?: 'PreviewTicketTranslationsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PreviewTicketTranslationsInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PreviewTicketTranslationsPayload = {
  __typename?: 'PreviewTicketTranslationsPayload';
  translations: Array<TicketTextTranslationPreviewItem>;
};

export type PreviewTicketTranslationsResult = PreviewTicketTranslationsError | PreviewTicketTranslationsPayload;

export type PromoteTenantManagerError = {
  __typename?: 'PromoteTenantManagerError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PromoteTenantManagerResult = {
  __typename?: 'PromoteTenantManagerResult';
  success: Scalars['Boolean']['output'];
};

export type PromoteTenantManagerUnion = PromoteTenantManagerError | PromoteTenantManagerResult;

export type Purchase = {
  __typename?: 'Purchase';
  customerEmail: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  referenceCode: Scalars['String']['output'];
  status: PurchaseStatus;
  ticket: Ticket;
  ticketPrice: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchaseCheckoutSessionStatus = {
  __typename?: 'PurchaseCheckoutSessionStatus';
  clientSecret?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  purchaseId?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type PurchaseCheckoutSessionStatusError = {
  __typename?: 'PurchaseCheckoutSessionStatusError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PurchaseCheckoutSessionStatusResult = PurchaseCheckoutSessionStatus | PurchaseCheckoutSessionStatusError;

export type PurchaseConnection = {
  __typename?: 'PurchaseConnection';
  edges: Array<PurchaseEdge>;
  pageInfo: PurchasePageInfo;
};

export type PurchaseEdge = {
  __typename?: 'PurchaseEdge';
  cursor: Scalars['String']['output'];
  node: Purchase;
};

export type PurchaseForVerificationError = {
  __typename?: 'PurchaseForVerificationError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type PurchaseForVerificationResult = PurchaseForVerificationError | TenantPurchase;

export type PurchasePageInfo = {
  __typename?: 'PurchasePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export enum PurchaseStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export enum PurchasedTicketStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Used = 'USED'
}

export type Query = {
  __typename?: 'Query';
  admin: Admin;
  areas: Array<Area>;
  guest: Guest;
  me: Me;
  purchaseCheckoutSessionStatus: PurchaseCheckoutSessionStatusResult;
  restaurant: Restaurant;
  searchAddressByPostalCode: SearchAddressByPostalCodeResult;
  tenant: Tenant;
  ticket: Ticket;
  tickets: TicketConnection;
};


export type QueryPurchaseCheckoutSessionStatusArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchAddressByPostalCodeArgs = {
  postalCode: Scalars['String']['input'];
};


export type QueryTicketArgs = {
  restaurantId: Scalars['ID']['input'];
  shopId?: InputMaybe<Scalars['ID']['input']>;
  ticketId: Scalars['ID']['input'];
};


export type QueryTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  areaId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhoneNumber: Scalars['String']['output'];
  contractPlan: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  operatingCompanyName: Scalars['String']['output'];
  shop: Shop;
  tickets: Array<Ticket>;
};

export type RevokeAdminRoleError = {
  __typename?: 'RevokeAdminRoleError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type RevokeAdminRoleInput = {
  userId: Scalars['ID']['input'];
};

export type RevokeAdminRoleResult = RevokeAdminRoleError | RevokeAdminRoleSuccess;

export type RevokeAdminRoleSuccess = {
  __typename?: 'RevokeAdminRoleSuccess';
  success: Scalars['Boolean']['output'];
};

export type SalesReportFilter = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type SaveCardError = {
  __typename?: 'SaveCardError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type SaveCardInput = {
  paymentMethodId: Scalars['ID']['input'];
};

export type SaveCardResult = SaveCardError | SaveCardSuccess;

export type SaveCardSuccess = {
  __typename?: 'SaveCardSuccess';
  brand: Scalars['String']['output'];
  cardId: Scalars['ID']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
};

export type SavedCard = {
  __typename?: 'SavedCard';
  brand: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type SearchAddressByPostalCodeError = {
  __typename?: 'SearchAddressByPostalCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type SearchAddressByPostalCodeResult = SearchAddressByPostalCodeError | SearchAddressByPostalCodeSuccess;

export type SearchAddressByPostalCodeSuccess = {
  __typename?: 'SearchAddressByPostalCodeSuccess';
  addresses: Array<AddressCandidate>;
};

export type Shop = {
  __typename?: 'Shop';
  buildingName?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  restaurant: Restaurant;
  streetAddress: Scalars['String']['output'];
  verificationCode?: Maybe<Scalars['String']['output']>;
  verificationMethod: TicketVerificationMethod;
};

export enum SupportedLanguage {
  En = 'EN',
  Ja = 'JA',
  Ko = 'KO',
  ZhHans = 'ZH_HANS',
  ZhHant = 'ZH_HANT'
}

export type Tenant = {
  __typename?: 'Tenant';
  currentMember?: Maybe<TenantMember>;
  member?: Maybe<TenantMember>;
  members: Array<TenantMember>;
  purchase: PurchaseForVerificationResult;
  purchases: TenantPurchaseConnection;
  restaurant: Restaurant;
  salesReport: TenantSalesReport;
  ticket?: Maybe<Ticket>;
  tickets: TenantTicketConnection;
};


export type TenantMemberArgs = {
  id: Scalars['ID']['input'];
};


export type TenantPurchaseArgs = {
  id: Scalars['ID']['input'];
};


export type TenantPurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenantPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type TenantSalesReportArgs = {
  filter: SalesReportFilter;
};


export type TenantTicketArgs = {
  id: Scalars['ID']['input'];
};


export type TenantTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TenantTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantMember = {
  __typename?: 'TenantMember';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role: TenantMembershipRole;
  status: TenantMemberStatus;
};

export enum TenantMemberStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum TenantMembershipRole {
  Manager = 'MANAGER',
  Staff = 'STAFF'
}

export type TenantPurchase = {
  __typename?: 'TenantPurchase';
  code: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  customerName?: Maybe<Scalars['String']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  status: TicketStatus;
  ticket?: Maybe<Ticket>;
  ticketPrice: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type TenantPurchaseConnection = {
  __typename?: 'TenantPurchaseConnection';
  edges: Array<TenantPurchaseEdge>;
  nodes: Array<TenantPurchase>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantPurchaseEdge = {
  __typename?: 'TenantPurchaseEdge';
  cursor: Scalars['String']['output'];
  node: TenantPurchase;
};

export type TenantPurchaseFilter = {
  purchasedAtEnd?: InputMaybe<Scalars['String']['input']>;
  purchasedAtStart?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TicketStatus>;
  ticketId?: InputMaybe<Scalars['ID']['input']>;
};

export type TenantSale = {
  __typename?: 'TenantSale';
  amount: Scalars['Int']['output'];
  customerEmail: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  quantity: Scalars['Int']['output'];
  status: PurchaseStatus;
  ticketName: Scalars['String']['output'];
};

export type TenantSalesReport = {
  __typename?: 'TenantSalesReport';
  sales: Array<TenantSale>;
  summary: TenantSalesSummary;
};

export type TenantSalesSummary = {
  __typename?: 'TenantSalesSummary';
  amountChange: Scalars['Int']['output'];
  averageValue: Scalars['Int']['output'];
  previousPeriodAmount: Scalars['Int']['output'];
  previousPeriodTickets: Scalars['Int']['output'];
  ticketsChange: Scalars['Int']['output'];
  totalAmount: Scalars['Int']['output'];
  totalTickets: Scalars['Int']['output'];
};

export type TenantTicketConnection = {
  __typename?: 'TenantTicketConnection';
  edges: Array<TenantTicketEdge>;
  nodes: Array<Ticket>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TenantTicketEdge = {
  __typename?: 'TenantTicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type TenantTicketFilter = {
  status?: InputMaybe<TicketPublicationStatus>;
};

export type TenantTicketVerification = {
  __typename?: 'TenantTicketVerification';
  code: Scalars['String']['output'];
  customerEmail: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  purchasedAt: Scalars['DateTime']['output'];
  qrCodeUrl?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  restaurant: Restaurant;
  status: TicketStatus;
  ticket: Ticket;
  totalAmount: Scalars['Int']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  availableStock?: Maybe<Scalars['Int']['output']>;
  availableWeekdays?: Maybe<Array<TicketAvailableWeekday>>;
  createdAt: Scalars['DateTime']['output'];
  currentPricePerPerson: Scalars['Int']['output'];
  dailyStock?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  expiryDays: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  maxPartySize?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pricePerPerson: Scalars['Int']['output'];
  pricingTiers: Array<TicketPricingTier>;
  purchaseTimeEndMinutes?: Maybe<Scalars['Int']['output']>;
  purchaseTimeStartMinutes?: Maybe<Scalars['Int']['output']>;
  restaurant: Restaurant;
  shop: Shop;
  status: TicketPublicationStatus;
  updatedAt: Scalars['DateTime']['output'];
  validTimeEndMinutes?: Maybe<Scalars['Int']['output']>;
  validTimeStartMinutes?: Maybe<Scalars['Int']['output']>;
};


export type TicketDescriptionArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};


export type TicketNameArgs = {
  lang?: InputMaybe<SupportedLanguage>;
};

export enum TicketAvailableWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type TicketConnection = {
  __typename?: 'TicketConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
};

export type TicketEdge = {
  __typename?: 'TicketEdge';
  cursor: Scalars['String']['output'];
  node: Ticket;
};

export type TicketPricingTier = {
  __typename?: 'TicketPricingTier';
  maxTicketNumber: Scalars['Int']['output'];
  minTicketNumber: Scalars['Int']['output'];
  pricePerPerson: Scalars['Int']['output'];
  upToQuantity: Scalars['Int']['output'];
};

export enum TicketPublicationStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Hidden = 'HIDDEN',
  Published = 'PUBLISHED'
}

export enum TicketStatus {
  Expired = 'EXPIRED',
  Used = 'USED',
  Valid = 'VALID'
}

export type TicketTextTranslationPreviewItem = {
  __typename?: 'TicketTextTranslationPreviewItem';
  description: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum TicketVerificationMethod {
  CodeInput = 'CODE_INPUT',
  QrCode = 'QR_CODE'
}

export type ToggleTicketActiveError = {
  __typename?: 'ToggleTicketActiveError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type ToggleTicketActiveResult = Ticket | ToggleTicketActiveError;

export type UpdateAdminSettingTermsError = {
  __typename?: 'UpdateAdminSettingTermsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateAdminSettingTermsInput = {
  privacyPolicy: Scalars['String']['input'];
  termsOfService: Scalars['String']['input'];
};

export type UpdateAdminSettingTermsResult = AdminSettingTerms | UpdateAdminSettingTermsError;

export type UpdateAdminUserError = {
  __typename?: 'UpdateAdminUserError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateAdminUserInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type UpdateAdminUserResult = AdminUser | UpdateAdminUserError;

export type UpdateCheckoutSessionTicketRecipientEmailError = {
  __typename?: 'UpdateCheckoutSessionTicketRecipientEmailError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateCheckoutSessionTicketRecipientEmailInput = {
  sessionId: Scalars['String']['input'];
  ticketRecipientEmail: Scalars['String']['input'];
};

export type UpdateCheckoutSessionTicketRecipientEmailResult = UpdateCheckoutSessionTicketRecipientEmailError | UpdateCheckoutSessionTicketRecipientEmailSuccess;

export type UpdateCheckoutSessionTicketRecipientEmailSuccess = {
  __typename?: 'UpdateCheckoutSessionTicketRecipientEmailSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  memberId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TenantMembershipRole>;
  status?: InputMaybe<TenantMemberStatus>;
};

export type UpdateShopSettingsInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  operatingCompanyName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  shopEmail?: InputMaybe<Scalars['String']['input']>;
  shopName?: InputMaybe<Scalars['String']['input']>;
  shopPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantMemberError = {
  __typename?: 'UpdateTenantMemberError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantMemberResult = TenantMember | UpdateTenantMemberError;

export type UpdateTenantShopSettingsError = {
  __typename?: 'UpdateTenantShopSettingsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantShopSettingsResult = Restaurant | UpdateTenantShopSettingsError;

export type UpdateTenantTicketError = {
  __typename?: 'UpdateTenantTicketError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantTicketInput = {
  availableWeekdays?: InputMaybe<Array<TicketAvailableWeekday>>;
  dailyStock?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiryDays?: InputMaybe<Scalars['Int']['input']>;
  imageUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  maxPartySize?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricingTiers?: InputMaybe<Array<UpdateTenantTicketPricingTierInput>>;
  purchaseTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  purchaseTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TicketPublicationStatus>;
  ticketId: Scalars['ID']['input'];
  validTimeEndMinutes?: InputMaybe<Scalars['Int']['input']>;
  validTimeStartMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTenantTicketPricingTierInput = {
  pricePerPerson: Scalars['Int']['input'];
  upToQuantity: Scalars['Int']['input'];
};

export type UpdateTenantTicketResult = Ticket | UpdateTenantTicketError;

export type UpdateTenantTicketSettingsError = {
  __typename?: 'UpdateTenantTicketSettingsError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UpdateTenantTicketSettingsResult = Shop | UpdateTenantTicketSettingsError;

export type UpdateTicketSettingsInput = {
  verificationCode?: InputMaybe<Scalars['String']['input']>;
  verificationMethod: TicketVerificationMethod;
};

export type UseGuestTicketWithCodeError = {
  __typename?: 'UseGuestTicketWithCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UseGuestTicketWithCodeInput = {
  ticketAccessToken: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UseGuestTicketWithCodeResult = Purchase | UseGuestTicketWithCodeError;

export type UseTicketWithCodeError = {
  __typename?: 'UseTicketWithCodeError';
  code: ErrorCode;
  message: Scalars['String']['output'];
};

export type UseTicketWithCodeInput = {
  purchaseId: Scalars['ID']['input'];
  verificationCode: Scalars['String']['input'];
};

export type UseTicketWithCodeResult = Purchase | UseTicketWithCodeError;

export type TenantAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantAccessQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', currentMember?: { __typename?: 'TenantMember', id: string, role: TenantMembershipRole, status: TenantMemberStatus } | null } };

export type TenantOnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantOnboardingStatusQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', id: string } } };

export type TenantShopSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantShopSettingsQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', id: string, contractPlan: string, operatingCompanyName: string, contactName: string, contactPhoneNumber: string, contactEmail: string, shop: { __typename?: 'Shop', id: string, name: string, postalCode: string, prefecture: string, city: string, streetAddress: string, buildingName?: string | null, phoneNumber: string, email: string } } } };

export type TenantPurchasesQueryVariables = Exact<{
  filter?: InputMaybe<TenantPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantPurchasesQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', shop: { __typename?: 'Shop', verificationCode?: string | null } }, purchases: { __typename?: 'TenantPurchaseConnection', totalCount: number, nodes: Array<{ __typename?: 'TenantPurchase', id: string, code: string, status: TicketStatus, customerName?: string | null, customerEmail: string, quantity: number, ticketPrice: number, totalAmount: number, purchasedAt: Date, usedAt?: Date | null, expiresAt: Date, ticket?: { __typename?: 'Ticket', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type PurchaseForVerificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PurchaseForVerificationQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', purchase:
      | { __typename?: 'PurchaseForVerificationError', code: ErrorCode, message: string }
      | { __typename?: 'TenantPurchase', id: string, status: TicketStatus, customerName?: string | null, customerEmail: string, quantity: number, purchasedAt: Date, ticket?: { __typename?: 'Ticket', id: string, name: string } | null }
     } };

export type MarkPurchaseUsedMutationVariables = Exact<{
  input: MarkPurchaseUsedInput;
}>;


export type MarkPurchaseUsedMutation = { __typename?: 'Mutation', markPurchaseUsed:
    | { __typename?: 'MarkPurchaseUsedError', code: ErrorCode, message: string }
    | { __typename?: 'TenantPurchase', id: string, status: TicketStatus, usedAt?: Date | null }
   };

export type InviteTenantMemberMutationVariables = Exact<{
  input: InviteMemberInput;
}>;


export type InviteTenantMemberMutation = { __typename?: 'Mutation', inviteTenantMember:
    | { __typename?: 'InviteTenantMemberError', code: ErrorCode, message: string }
    | { __typename?: 'TenantMember', id: string }
   };

export type TenantMemberQueryVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type TenantMemberQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', members: Array<{ __typename?: 'TenantMember', id: string, role: TenantMembershipRole, status: TenantMemberStatus }>, member?: { __typename?: 'TenantMember', id: string, name?: string | null, email?: string | null, role: TenantMembershipRole, status: TenantMemberStatus } | null } };

export type UpdateTenantMemberMutationVariables = Exact<{
  input: UpdateMemberInput;
}>;


export type UpdateTenantMemberMutation = { __typename?: 'Mutation', updateTenantMember:
    | { __typename?: 'TenantMember', id: string, name?: string | null, email?: string | null, role: TenantMembershipRole }
    | { __typename?: 'UpdateTenantMemberError', code: ErrorCode, message: string }
   };

export type DeleteTenantMemberMutationVariables = Exact<{
  memberId: Scalars['ID']['input'];
}>;


export type DeleteTenantMemberMutation = { __typename?: 'Mutation', deleteTenantMember:
    | { __typename?: 'DeleteTenantMemberError', code: ErrorCode, message: string }
    | { __typename?: 'DeleteTenantMemberResult', success: boolean }
   };

export type TenantMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantMembersQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', members: Array<{ __typename?: 'TenantMember', id: string, name?: string | null, email?: string | null, role: TenantMembershipRole, status: TenantMemberStatus, lastLoginAt?: Date | null }> } };

export type TenantSalesReportQueryVariables = Exact<{
  filter: SalesReportFilter;
}>;


export type TenantSalesReportQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', salesReport: { __typename?: 'TenantSalesReport', summary: { __typename?: 'TenantSalesSummary', totalAmount: number, totalTickets: number, averageValue: number } } } };

export type TenantSalesPurchasesQueryVariables = Exact<{
  filter?: InputMaybe<TenantPurchaseFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantSalesPurchasesQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', purchases: { __typename?: 'TenantPurchaseConnection', totalCount: number, nodes: Array<{ __typename?: 'TenantPurchase', id: string, code: string, status: TicketStatus, customerName?: string | null, customerEmail: string, quantity: number, ticketPrice: number, totalAmount: number, purchasedAt: Date, expiresAt: Date, ticket?: { __typename?: 'Ticket', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type TenantSalesTicketsQueryVariables = Exact<{
  filter?: InputMaybe<TenantTicketFilter>;
}>;


export type TenantSalesTicketsQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', tickets: { __typename?: 'TenantTicketConnection', nodes: Array<{ __typename?: 'Ticket', id: string, name: string }> } } };

export type CreateTenantAccountMutationVariables = Exact<{
  input: CreateTenantAccountInput;
}>;


export type CreateTenantAccountMutation = { __typename?: 'Mutation', createTenantAccount:
    | { __typename?: 'CreateTenantAccountError', code: ErrorCode, message: string }
    | { __typename?: 'Restaurant', id: string }
   };

export type SearchAddressByPostalCodeQueryVariables = Exact<{
  postalCode: Scalars['String']['input'];
}>;


export type SearchAddressByPostalCodeQuery = { __typename?: 'Query', searchAddressByPostalCode:
    | { __typename?: 'SearchAddressByPostalCodeError', code: ErrorCode, message: string }
    | { __typename?: 'SearchAddressByPostalCodeSuccess', addresses: Array<{ __typename?: 'AddressCandidate', postalCode: string, prefecture: string, city: string, streetAddress: string }> }
   };

export type CreateTenantTicketMutationVariables = Exact<{
  input: CreateTenantTicketInput;
}>;


export type CreateTenantTicketMutation = { __typename?: 'Mutation', createTenantTicket:
    | { __typename?: 'CreateTenantTicketError', code: ErrorCode, message: string }
    | { __typename?: 'Ticket', id: string }
   };

export type UpdateTenantTicketForImagesMutationVariables = Exact<{
  input: UpdateTenantTicketInput;
}>;


export type UpdateTenantTicketForImagesMutation = { __typename?: 'Mutation', updateTenantTicket:
    | { __typename?: 'Ticket', id: string }
    | { __typename?: 'UpdateTenantTicketError', code: ErrorCode, message: string }
   };

export type TenantUploadPathContextQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantUploadPathContextQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', id: string } } } };

export type TenantTicketDetailQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type TenantTicketDetailQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', id: string }, ticket?: { __typename?: 'Ticket', id: string, name: string, description: string, imageUrls: Array<string>, pricePerPerson: number, maxPartySize?: number | null, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, purchaseTimeStartMinutes?: number | null, purchaseTimeEndMinutes?: number | null, dailyStock?: number | null, expiryDays: number, availableWeekdays?: Array<TicketAvailableWeekday> | null, status: TicketPublicationStatus, jaName: string, jaDescription: string, enName: string, enDescription: string, zhHansName: string, zhHansDescription: string, zhHantName: string, zhHantDescription: string, koName: string, koDescription: string, pricingTiers: Array<{ __typename?: 'TicketPricingTier', minTicketNumber: number, maxTicketNumber: number, pricePerPerson: number }> } | null } };

export type TenantTicketSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantTicketSettingsQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', shop: { __typename?: 'Shop', verificationMethod: TicketVerificationMethod, verificationCode?: string | null } } } };

export type DuplicateTenantTicketMutationVariables = Exact<{
  input: DuplicateTenantTicketInput;
}>;


export type DuplicateTenantTicketMutation = { __typename?: 'Mutation', duplicateTenantTicket:
    | { __typename: 'DuplicateTenantTicketError', code: ErrorCode, message: string }
    | { __typename: 'Ticket', id: string }
   };

export type TenantTicketForEditQueryVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type TenantTicketForEditQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', restaurant: { __typename?: 'Restaurant', id: string, shop: { __typename?: 'Shop', id: string, verificationMethod: TicketVerificationMethod, verificationCode?: string | null } }, ticket?: { __typename?: 'Ticket', id: string, name: string, description: string, imageUrls: Array<string>, pricePerPerson: number, maxPartySize?: number | null, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, purchaseTimeStartMinutes?: number | null, purchaseTimeEndMinutes?: number | null, dailyStock?: number | null, expiryDays: number, availableWeekdays?: Array<TicketAvailableWeekday> | null, status: TicketPublicationStatus, pricingTiers: Array<{ __typename?: 'TicketPricingTier', upToQuantity: number, pricePerPerson: number }> } | null } };

export type UpdateTenantTicketMutationVariables = Exact<{
  input: UpdateTenantTicketInput;
}>;


export type UpdateTenantTicketMutation = { __typename?: 'Mutation', updateTenantTicket:
    | { __typename?: 'Ticket', id: string }
    | { __typename?: 'UpdateTenantTicketError', code: ErrorCode, message: string }
   };

export type DeleteTenantTicketMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type DeleteTenantTicketMutation = { __typename?: 'Mutation', deleteTenantTicket:
    | { __typename?: 'DeleteTenantTicketError', code: ErrorCode, message: string }
    | { __typename?: 'DeleteTenantTicketResult', success: boolean }
   };

export type TenantTicketsQueryVariables = Exact<{
  filter?: InputMaybe<TenantTicketFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantTicketsQuery = { __typename?: 'Query', tenant: { __typename?: 'Tenant', tickets: { __typename?: 'TenantTicketConnection', totalCount: number, nodes: Array<{ __typename?: 'Ticket', id: string, name: string, pricePerPerson: number, validTimeStartMinutes?: number | null, validTimeEndMinutes?: number | null, dailyStock?: number | null, status: TicketPublicationStatus }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } } };

export type ToggleTicketActiveMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
  status: TicketPublicationStatus;
}>;


export type ToggleTicketActiveMutation = { __typename?: 'Mutation', toggleTicketActive:
    | { __typename?: 'Ticket', id: string, status: TicketPublicationStatus }
    | { __typename?: 'ToggleTicketActiveError', code: ErrorCode, message: string }
   };

export type PreviewTicketTranslationsMutationVariables = Exact<{
  input: PreviewTicketTranslationsInput;
}>;


export type PreviewTicketTranslationsMutation = { __typename?: 'Mutation', previewTicketTranslations:
    | { __typename?: 'PreviewTicketTranslationsError', code: ErrorCode, message: string }
    | { __typename?: 'PreviewTicketTranslationsPayload', translations: Array<{ __typename?: 'TicketTextTranslationPreviewItem', lang: string, name: string, description: string }> }
   };

export type UpdateTenantTicketSettingsMutationVariables = Exact<{
  input: UpdateTicketSettingsInput;
}>;


export type UpdateTenantTicketSettingsMutation = { __typename?: 'Mutation', updateTenantTicketSettings:
    | { __typename?: 'Shop', verificationMethod: TicketVerificationMethod, verificationCode?: string | null }
    | { __typename?: 'UpdateTenantTicketSettingsError', code: ErrorCode, message: string }
   };


export const TenantAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TenantAccessQuery, TenantAccessQueryVariables>;
export const TenantOnboardingStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantOnboardingStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<TenantOnboardingStatusQuery, TenantOnboardingStatusQueryVariables>;
export const TenantShopSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantShopSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contractPlan"}},{"kind":"Field","name":{"kind":"Name","value":"operatingCompanyName"}},{"kind":"Field","name":{"kind":"Name","value":"contactName"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"buildingName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantShopSettingsQuery, TenantShopSettingsQueryVariables>;
export const TenantPurchasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantPurchases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantPurchaseFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"ticketPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantPurchasesQuery, TenantPurchasesQueryVariables>;
export const PurchaseForVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchaseForVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantPurchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseForVerificationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseForVerificationQuery, PurchaseForVerificationQueryVariables>;
export const MarkPurchaseUsedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkPurchaseUsed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkPurchaseUsedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markPurchaseUsed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantPurchase"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarkPurchaseUsedError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<MarkPurchaseUsedMutation, MarkPurchaseUsedMutationVariables>;
export const InviteTenantMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteTenantMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteTenantMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InviteTenantMemberError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InviteTenantMemberMutation, InviteTenantMemberMutationVariables>;
export const TenantMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TenantMemberQuery, TenantMemberQueryVariables>;
export const UpdateTenantMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTenantMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TenantMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantMemberError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantMemberMutation, UpdateTenantMemberMutationVariables>;
export const DeleteTenantMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTenantMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTenantMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTenantMemberResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTenantMemberError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTenantMemberMutation, DeleteTenantMemberMutationVariables>;
export const TenantMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastLoginAt"}}]}}]}}]}}]} as unknown as DocumentNode<TenantMembersQuery, TenantMembersQueryVariables>;
export const TenantSalesReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantSalesReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SalesReportFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"salesReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"totalTickets"}},{"kind":"Field","name":{"kind":"Name","value":"averageValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantSalesReportQuery, TenantSalesReportQueryVariables>;
export const TenantSalesPurchasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantSalesPurchases"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantPurchaseFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"customerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"ticketPrice"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}},{"kind":"Field","name":{"kind":"Name","value":"purchasedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantSalesPurchasesQuery, TenantSalesPurchasesQueryVariables>;
export const TenantSalesTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantSalesTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantTicketFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantSalesTicketsQuery, TenantSalesTicketsQueryVariables>;
export const CreateTenantAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTenantAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenantAccountInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTenantAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Restaurant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenantAccountError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTenantAccountMutation, CreateTenantAccountMutationVariables>;
export const SearchAddressByPostalCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchAddressByPostalCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchAddressByPostalCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"postalCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postalCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SearchAddressByPostalCodeSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"prefecture"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SearchAddressByPostalCodeError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SearchAddressByPostalCodeQuery, SearchAddressByPostalCodeQueryVariables>;
export const CreateTenantTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTenantTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenantTicketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTenantTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTenantTicketError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<CreateTenantTicketMutation, CreateTenantTicketMutationVariables>;
export const UpdateTenantTicketForImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantTicketForImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantTicketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTenantTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantTicketError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantTicketForImagesMutation, UpdateTenantTicketForImagesMutationVariables>;
export const TenantUploadPathContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantUploadPathContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantUploadPathContextQuery, TenantUploadPathContextQueryVariables>;
export const TenantTicketDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantTicketDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"jaName"},"name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"JA"}}]},{"kind":"Field","alias":{"kind":"Name","value":"jaDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"JA"}}]},{"kind":"Field","alias":{"kind":"Name","value":"enName"},"name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"EN"}}]},{"kind":"Field","alias":{"kind":"Name","value":"enDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"EN"}}]},{"kind":"Field","alias":{"kind":"Name","value":"zhHansName"},"name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"ZH_HANS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"zhHansDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"ZH_HANS"}}]},{"kind":"Field","alias":{"kind":"Name","value":"zhHantName"},"name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"ZH_HANT"}}]},{"kind":"Field","alias":{"kind":"Name","value":"zhHantDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"ZH_HANT"}}]},{"kind":"Field","alias":{"kind":"Name","value":"koName"},"name":{"kind":"Name","value":"name"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"KO"}}]},{"kind":"Field","alias":{"kind":"Name","value":"koDescription"},"name":{"kind":"Name","value":"description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"EnumValue","value":"KO"}}]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minTicketNumber"}},{"kind":"Field","name":{"kind":"Name","value":"maxTicketNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPartySize"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"dailyStock"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDays"}},{"kind":"Field","name":{"kind":"Name","value":"availableWeekdays"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TenantTicketDetailQuery, TenantTicketDetailQueryVariables>;
export const TenantTicketSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantTicketSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"verificationCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantTicketSettingsQuery, TenantTicketSettingsQueryVariables>;
export const DuplicateTenantTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateTenantTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateTenantTicketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duplicateTenantTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DuplicateTenantTicketError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DuplicateTenantTicketMutation, DuplicateTenantTicketMutationVariables>;
export const TenantTicketForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantTicketForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shop"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verificationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"verificationCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"pricingTiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upToQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxPartySize"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"dailyStock"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDays"}},{"kind":"Field","name":{"kind":"Name","value":"availableWeekdays"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<TenantTicketForEditQuery, TenantTicketForEditQueryVariables>;
export const UpdateTenantTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantTicketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTenantTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantTicketError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantTicketMutation, UpdateTenantTicketMutationVariables>;
export const DeleteTenantTicketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTenantTicket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTenantTicket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ticketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTenantTicketResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTenantTicketError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTenantTicketMutation, DeleteTenantTicketMutationVariables>;
export const TenantTicketsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TenantTickets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantTicketFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tickets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerPerson"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeStartMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"validTimeEndMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"dailyStock"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TenantTicketsQuery, TenantTicketsQueryVariables>;
export const ToggleTicketActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleTicketActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TicketPublicationStatus"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleTicketActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ticketId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ticketId"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Ticket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ToggleTicketActiveError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ToggleTicketActiveMutation, ToggleTicketActiveMutationVariables>;
export const PreviewTicketTranslationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreviewTicketTranslations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreviewTicketTranslationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewTicketTranslations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreviewTicketTranslationsPayload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lang"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PreviewTicketTranslationsError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<PreviewTicketTranslationsMutation, PreviewTicketTranslationsMutationVariables>;
export const UpdateTenantTicketSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantTicketSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTicketSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTenantTicketSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Shop"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verificationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"verificationCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTenantTicketSettingsError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantTicketSettingsMutation, UpdateTenantTicketSettingsMutationVariables>;